/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import { getLoginUser } from './loginService';

const base_url = `${process.env.BACKEND_API_BASE_URL}/ringcentral-get-call.php`;

export const ringcentralService = {
  get_call: async () =>
    axios.get(base_url, {
      params: {
        token: getLoginUser().token,
      },
    }),
};
